import React from "react";
import { useState,useEffect } from "react";
import { Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { CREATE_TRIVVY_MODAL_IMAGES, minPlanLimitCheck } from "../../data";
import "./createTrivia.css";
import CreateTriviaPopup from "./CreateTriviaPopup";
import TrivvyTemplatesModalMain from "./TrivvyTemplatesModalMain";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import CheckBox from "rc-checkbox";
import {
  LuArrowRight,
  LuBrainCircuit,
  LuMessageCircle,
  LuMessagesSquare,
  LuPencilLine,
  LuPlus,
  LuPlusCircle,
  LuSparkles,
} from "react-icons/lu";
import {
  BWAI_PICKER_TITLE,
  BWAI_PICKER_USER_CHATS_TITLE,
  BWAI_PICKER_USER_CHATS_DESC,
  BWAI_PICKER_SURVEY_TITLE,
  BWAI_PICKER_SURVEY_DESC,
  BWAI_PICKER_MESSAGING_TITLE,
  BWAI_PICKER_MESSAGING_DESC,
  BWAI_PICKER_KC_TITLE,
  BWAI_PICKER_KC_DESC,
  BWAI_PICKER_MANUAL,
  BWAI_PICKER_NEVER_SHOW,
  BWAI_PICKER_CANCEL,
  BWAI_HEADER_MANUAL_SURVEY,
} from "./createTriviaCopy";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import * as actionCreators from "../../../../modules/actions";
import { CREATE_TRIVVY_INSUFFICIENT_RESPONSES_NOTE } from "../../../../utils/constants";
import ScheduleQuestionsModal from "../../LibraryModule/Components/ScheduleQuestionsModal";
import ScheduleQuestionsModalWrapper from "../../LibraryModule/Components/ScheduleQuestionsModalWrapper";
import CreateCustomTrivvyPopup from "./CreateCustomTrivvyPopup";
// The picker's illustration PNGs (templates-trivvy / work-with-ai) are gone:
// the redesign replaces them with the tinted vector icons on each card.
import trivvyQuestionsBank from '../../../../assets/create-trivvy-modal/trivvy-question-bank.png'

// The `selectedType` the Survey Generator ("Built with AI") screen resolves to.
// Exported so callers can open straight to it by name rather than a bare 4.
export const TRIVVY_TYPE_BUILT_WITH_AI = 4;

// The three starting points offered on the picker screen, in display order.
// Kept as data rather than three near-identical JSX blocks so a card can be
// added, reordered or reworded in one place. `type` is the existing
// selectedType value each card resolves to — unchanged by the redesign.
// `tone` drives two class names: `is-tint-<tone>` on the icon tile and
// `is-type-<tone>` on the card (which sets the accent its border and selected
// ring use). One field so the two can never drift apart.
const TRIVVY_TYPE_OPTIONS = [
  {
    type: "user-chats",
    Icon: LuMessagesSquare,
    tone: "blue",
    title: BWAI_PICKER_USER_CHATS_TITLE,
    description: BWAI_PICKER_USER_CHATS_DESC,
    isNavigation: true,
  },
  {
    type: 4,
    Icon: LuSparkles,
    tone: "green",
    title: BWAI_PICKER_SURVEY_TITLE,
    description: BWAI_PICKER_SURVEY_DESC,
  },
  {
    type: 5,
    Icon: LuMessageCircle,
    tone: "orange",
    title: BWAI_PICKER_MESSAGING_TITLE,
    description: BWAI_PICKER_MESSAGING_DESC,
  },
  {
    type: 2,
    Icon: LuBrainCircuit,
    tone: "purple",
    title: BWAI_PICKER_KC_TITLE,
    description: BWAI_PICKER_KC_DESC,
  },
];

function CreateTriviaModalMain(props) {
  const [selectedType, setSelectedType] = useState(null);
  const [insufficientNoteDismissed, setInsufficientNoteDismissed] = useState(false);

  const user = props.user;
  const orgObject =
    user && user.profile && user.profile.organizationId
      ? user.profile.organizationId
      : null;

  const hasCounters =
    orgObject &&
    typeof orgObject.totalTriviaResponsesCount === "number" &&
    typeof orgObject.submittedTriviaResponsesCount === "number" &&
    typeof orgObject.smsLimit === "number" &&
    typeof orgObject.totalSmsSent === "number";

  const remainingResponses = hasCounters
    ? orgObject.totalTriviaResponsesCount - orgObject.submittedTriviaResponsesCount
    : null;
  const remainingSMS = hasCounters
    ? orgObject.smsLimit - orgObject.totalSmsSent
    : null;

  const showInsufficientNote =
    hasCounters &&
    !insufficientNoteDismissed &&
    (remainingResponses <= 0 || remainingSMS <= 0);

  useEffect(() => {
    if(props.onlyShowMessageWindow){
      setSelectedType(5)
    }
    if (props.openDirectToKnowledgeCheck) {
      setSelectedType(2)
    }
    if (props.initialSelectedType) {
      setSelectedType(props.initialSelectedType);
    }
  }, [])
  

  const handleUpdateFlag = (val) => {
    axios
      .post(url.updateTrivvyModalFlag, {
        hideCreateTrivvyModal: val,
      })
      .then((data) => {
        props.updateUserSuccess({
          ...user.profile,
          hideCreateTrivvyModal: val,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // User Chats isn't a creation flow: it closes the modal and routes there
  // instead of swapping in an inline creation screen like the other cards.
  const handleTypeCardClick = (option) => {
    if (option.isNavigation) {
      if (props.onClose) {
        props.onClose();
      }
      if (props.history && user && user.profile && user.profile.organizationId) {
        props.history.push(
          `/home/trivia/${user.profile.organizationId._id}/user-chats`
        );
      }
      return;
    }
    setSelectedType(option.type);
  };

  // Screens carrying the modernized design: everything except the templates
  // screen (3), which is not reachable from the picker today.
  const isRestyledScreen =
    selectedType == null ||
    selectedType === 1 ||
    selectedType === 2 ||
    selectedType === 4 ||
    selectedType === 5;

  // The type's accent, applied to the dialog so a creation flow is tinted with
  // the colour of the card that opened it. Only the types whose picker card has
  // a tint carry one; the rest fall back to the neutral default.
  const accentClass = () => {
    if (selectedType === 2) {
      return " is-type-purple";
    }
    if (selectedType === 4) {
      return " is-type-green";
    }
    if (selectedType === 5) {
      return " is-type-orange";
    }
    return "";
  };

  // Derived, not stored: stays true across the swap to Custom Trivvy and back,
  // and is falsy for every opener that did not ask for a direct type.
  const openedDirectToAi =
    props.initialSelectedType === TRIVVY_TYPE_BUILT_WITH_AI;

  const handleCustomTrivvyBack = () => {
    if (openedDirectToAi) {
      setSelectedType(TRIVVY_TYPE_BUILT_WITH_AI);
    } else {
      setSelectedType(null);
    }
  };

  return (
    <Modal
      isOpen={props.open}
      className={
        isRestyledScreen
          ? `create-trivvy-modal-main-popup-css bwai-modal${accentClass()}`
          : "create-trivvy-modal-main-popup-css"
      }
    >
      <ModalHeader
        className={
          isRestyledScreen ? "bwai_modal_header" : "trivia_modal_header_bg"
        }
        toggle={props.onClose}
      >
        {selectedType == null ? (
          <React.Fragment>
            <span className="bwai_title_chip is-tint-neutral">
              <LuPlusCircle />
            </span>
            <span className="bwai_title_block">
              <span className="bwai_title_text">{BWAI_PICKER_TITLE}</span>
            </span>
          </React.Fragment>
        ) : selectedType === 4 ? (
          <React.Fragment>
            <span className="bwai_title_chip">
              <LuSparkles />
            </span>
            <span className="bwai_title_text">Built with AI</span>
            {openedDirectToAi && (
              <button
                type="button"
                className="bwai_header_manual_btn"
                onClick={() => setSelectedType(1)}
              >
                <LuPencilLine />
                {BWAI_HEADER_MANUAL_SURVEY}
              </button>
            )}
          </React.Fragment>
        ) : selectedType === 1 ? (
          <React.Fragment>
            <span className="bwai_title_chip is-tint-neutral">
              <LuPencilLine />
            </span>
            <span className="bwai_title_text">Custom Trivvy</span>
          </React.Fragment>
        ) : selectedType === 2 ? (
          <React.Fragment>
            {/* Same icon and tint as the Knowledge Checks card on the picker. */}
            <span className="bwai_title_chip is-tint-purple">
              <LuBrainCircuit />
            </span>
            <span className="bwai_title_text">
              Smart Trivvy generated by AI
            </span>
          </React.Fragment>
        ) : selectedType === 3 ? (
          "Trivvy templates "
        ) : selectedType == 5 ? (
          <React.Fragment>
            {/* Same icon and tint as the Messaging card on the picker. */}
            <span className="bwai_title_chip is-tint-orange">
              <LuMessageCircle />
            </span>
            <span className="bwai_title_text">Messaging</span>
          </React.Fragment>
        ) : (
          BWAI_PICKER_TITLE
        )}
      </ModalHeader>
      <ModalBody className="pt-3 px-4 pb-0">
        {showInsufficientNote && (
          <Alert
            color="danger"
            isOpen={showInsufficientNote}
            toggle={() => setInsufficientNoteDismissed(true)}
            className="alert-insufficient-credits"
          >
            {CREATE_TRIVVY_INSUFFICIENT_RESPONSES_NOTE}
          </Alert>
        )}
        {selectedType == null ? (
          <div>
            <div>
              {/* <div className="my-2 trivvy-create-popup-title">
                {!props.canCreateRewards && props.firstTimePopupText ? (
                  props.firstTimePopupText
                ) : (
                  <span>
                    Select one of the options below to create your trivvy{" "}
                  </span>
                )}
                {props.canCreateRewards ? (
                  <span>
                    {" "}
                    or{" "}
                    <span
                      className="text-info cursor-pointer"
                      onClick={() => {
                        if (props.goToRewards) {
                          props.goToRewards();
                        }
                      }}
                    >
                      create a reward
                    </span>{" "}
                    for your trivvys{" "}
                  </span>
                ) : (
                  ""
                )}
              </div> */}

              <div className="bwai_type_list">
                {TRIVVY_TYPE_OPTIONS.map((option) => {
                  const CardIcon = option.Icon;
                  return (
                    <div
                      key={option.type}
                      className={`bwai_type_card is-type-${option.tone}`}
                      role="button"
                      tabIndex={0}
                      onClick={() => handleTypeCardClick(option)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          // Space would otherwise scroll the modal body.
                          e.preventDefault();
                          handleTypeCardClick(option);
                        }
                      }}
                    >
                      <span
                        className={`bwai_type_icon is-tint-${option.tone}`}
                        aria-hidden="true"
                      >
                        <CardIcon />
                      </span>
                      <span className="bwai_type_body">
                        <span className="bwai_type_title">{option.title}</span>
                        <span className="bwai_type_desc">
                          {option.description}
                        </span>
                      </span>
                      <span className="bwai_type_arrow" aria-hidden="true">
                        <LuArrowRight />
                      </span>
                    </div>
                  );
                })}
                {/* <div
                className="trivvy-create-option-card custom-create"
                onClick={() => setSelectedType(1)}
              >
                <img
                  src={CREATE_TRIVVY_MODAL_IMAGES.CUSTOM}
                  className="trivvy-create-option-card-img"
                />
                <div className="trivvy-create-option-card-txt">
                  {" "}
                  <b>Create manual survey:</b> Create a custom survey with your own questions.
                </div>
              </div> */}

                {/* <div
                className="trivvy-create-option-card ai-create"
                onClick={() => setSelectedType(2)}
              >
                <img
                  src={CREATE_TRIVVY_MODAL_IMAGES.AI}
                  className="trivvy-create-option-card-img"
                />
                <div className="trivvy-create-option-card-txt">
                  {" "}
                  <b>AI-generated trivvys</b> in under a minute from any
                  document, link or text
                </div>
              </div> */}

                {/* <div
                className="trivvy-create-option-card custom-create"
                onClick={() => setSelectedType(3)}
              >
                <img
                  src={CREATE_TRIVVY_MODAL_IMAGES.CUSTOM}
                  className="trivvy-create-option-card-img"
                />
                <div className="trivvy-create-option-card-txt">
                  <b>Feedback Templates:</b> Use ready made templates to get feedback from your customers or employees
                </div>
              </div> */}

                {/* 
              <div
                className="trivvy-create-option-card qb-create"
                onClick={() => {
                  if (props.history) {
                    props.history.push(
                      `/home/trivia/${user.profile.organizationId._id}/library`
                    );
                  }
                }}
              >
                <img
                  src="https://dev-oo-app-api.s3.us-east-2.amazonaws.com/trivvy-question-bank.png"
                  className="trivvy-create-option-card-img"
                />
                <div className="trivvy-create-option-card-txt">
                  {" "}
                  Create and auto schedule several Trivvys from longer content
                  in the <b>Library</b>
                </div>
              </div> */}
              </div>
            </div>

            {/* Escape hatch, deliberately outside the card group — but it
                commits on click exactly like the cards above. */}
            <div className="bwai_manual_row">
              <span
                className="bwai_manual_btn"
                role="button"
                tabIndex={0}
                onClick={() => {
                  setSelectedType(1);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setSelectedType(1);
                  }
                }}
              >
                <LuPlus />
                {BWAI_PICKER_MANUAL}
              </span>
            </div>

            <ModalFooter className="justify-content-between bwai_footer">
              <label className="bwai_never_show">
                <CheckBox
                  checked={user.profile.hideCreateTrivvyModal}
                  onChange={(e) => {
                    if (e.target.checked && props.setCreateModalState) {
                      props.setCreateModalState(false);
                    }
                    handleUpdateFlag(e.target.checked);
                  }}
                />
                <span className="bwai_never_show_text">
                  {BWAI_PICKER_NEVER_SHOW}
                </span>
              </label>
              <div className="bwai_footer_actions">
                <Button
                  className="bwai_btn_outline"
                  onClick={() => {
                    if (props.onClose) {
                      props.onClose();
                    }
                  }}
                >
                  {BWAI_PICKER_CANCEL}
                </Button>
              </div>
            </ModalFooter>
          </div>
        ) : (
          <div>
            {selectedType === 1 ? (
              <CreateCustomTrivvyPopup
                uiType="INLINE"
                {...props}
                autoSelectedTrivvyType={"CUSTOM"}
                onBack={handleCustomTrivvyBack}
              />
            ) : selectedType === 2 ? (
              <CreateTriviaPopup
                uiType="INLINE"
                restyled
                {...props}
                autoSelectedTrivvyType={"AI"}
                hideBackOnFirstStep={props.openDirectToKnowledgeCheck}
                onBack={() => setSelectedType(null)}
              />
            ) : selectedType === 3 ? (
              <TrivvyTemplatesModalMain
                uiType="INLINE"
                {...props}
                onBack={() => setSelectedType(null)}
              />
            ) : selectedType === 4 ? (
              <CreateTriviaPopup
                uiType="INLINE"
                onlyAllowCustomTextPrompt
                {...props}
                autoSelectedTrivvyType={"AI"}
                onBack={() => setSelectedType(null)}
                hideBackOnFirstStep={openedDirectToAi}
              />
            ) : selectedType === 5 ? (
              <CreateCustomTrivvyPopup
                uiType="INLINE"
                {...props}
                autoSelectedTrivvyType={"CUSTOM"}
                isMessaging={true}
                onBack={() => setSelectedType(null)}
              />
            ) : (
              ""
            )}
          </div>
        )}
      </ModalBody>

      {/* The picker's "Never show again" checkbox moved into the styled footer
          inside the body, so this bar is always empty on the restyled screens
          and `.bwai-modal > .modal-content > .modal-footer:empty` hides it. */}
      <ModalFooter />
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateUserSuccess: (data) =>
      dispatch(actionCreators.updateUserSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CreateTriviaModalMain));
